import React from 'react';
import FontAwesome from 'react-fontawesome';

import { isFontAwesomeIRI, normalizeFontAwesomeIRI } from '../../lib/iris';

export interface ImageProps {
  alt?: string;
  ariaLabel?: string;
  className?: string;
  url: string;
  spin?: boolean;
  style?: React.CSSProperties;
}

const Image = (props: ImageProps): JSX.Element => {
  const { ...overrideProps } = props;
  const { alt, ariaLabel, className, spin, style, url } = overrideProps;

  if (isFontAwesomeIRI(url)) {
    return (
      <span className={className}>
        <FontAwesome ariaLabel={ariaLabel || ''} name={normalizeFontAwesomeIRI(url)} spin={spin} style={style} />
      </span>
    );
  }

  return <img alt={alt} aria-label={ariaLabel} className={className} src={url} style={style} />;
};

export default Image;
